import { render, staticRenderFns } from "./UDropdown.vue?vue&type=template&id=56da59fa&scoped=true"
import script from "./UDropdown.vue?vue&type=script&lang=js"
export * from "./UDropdown.vue?vue&type=script&lang=js"
import style0 from "./UDropdown.vue?vue&type=style&index=0&id=56da59fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da59fa",
  null
  
)

export default component.exports